<template>
  <div class="backimg">
    <div class="search-content" style="width:1256px;margin: 0 auto;">
      <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">

        <el-menu-item index="1" v-if="auditright">待审核</el-menu-item>
        <el-menu-item index="2" v-if="viewright">已审核</el-menu-item>
        <el-menu-item index="3">跟踪日志</el-menu-item>
      </el-menu>
      <div class="line"></div>
    </div>
    <el-main>
      <comment :is="currentcomponent" :auditstatus="status" v-if="visible"></comment>
    </el-main>

  </div>

</template>

<script>
  import waitauditList from './waitauditList';
  import TrackingLog from './TrackingLog';

  export default {
    data() {
      return {
        auditright:false,
        viewright:false,
        activeIndex: '1',
        currentcomponent: '',
        visible: true,
        status: '1',
      };
    },
    methods: {
      handleSelect(key, keyPath) {
        this.status = key
        this.visible = false
        if (key == 3) {
          this.currentcomponent = 'TrackingLog'
        } else {
          this.currentcomponent = 'waitauditList'
        }
        this.$nextTick(() => {
          this.visible = true
        })
      },
    },
    mounted() {
      this.auditright = this.$checkRight("审核门店")
      this.viewright=this.$checkRight("查看门店")
      this.activeIndex = this.auditright ? '1' : '3';
      this.currentcomponent = this.auditright ? "waitauditList" : "TrackingLog";
    },
    components: {
      waitauditList,
      TrackingLog
    }

  }


</script>
<style scoped>
  .el-main {
    padding: 0px;
    /*height: calc(100vh - 97px);*/
    width: 1256px;
    margin: 0 auto;
    background-color: white;
    overflow: auto;
  }

  .el-menu-item {
    height: 48px !important;
    line-height: 48px !important;
  }


</style>



// WEBPACK FOOTER //
// src/components/workflow/waitaudit/Waitaudit.vue